import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "weights_drill_down",
  "use": "weights_drill_down-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"weights_drill_down\"><path d=\"M13.222 8.333V3.89H7.89v1.555H4.11v-.666h2V.333H.778v4.445h2v7.333h5.11v1.556h5.334V9.222H7.89v1.556H4.11v-4H7.89v1.555zm-4-3.11h2.667V7H9.222zm0 5.333h2.667v1.777H9.222zm-7.11-7.112V1.667h2.666v1.777z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol